import React from "react";

export const Close: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.27076 11.4223C1.90975 11.7833 1.90975 12.3687 2.27076 12.7297C2.63178 13.0907 3.21711 13.0907 3.57813 12.7297L7.50023 8.80759L11.4223 12.7297C11.7833 13.0907 12.3687 13.0907 12.7297 12.7297C13.0907 12.3687 13.0907 11.7833 12.7297 11.4223L8.80759 7.50023L12.7297 3.57813C13.0907 3.21711 13.0907 2.63178 12.7297 2.27076C12.3687 1.90975 11.7833 1.90975 11.4223 2.27076L7.50023 6.19286L3.57813 2.27076C3.21711 1.90975 2.63178 1.90975 2.27076 2.27076C1.90975 2.63178 1.90975 3.21711 2.27076 3.57813L6.19286 7.50023L2.27076 11.4223Z"
        fill="currentColor"
      />
    </svg>
  );
};
